import { isValidE164 } from './phone'

export interface PartnerApplication {
  name: string; email: string; company: string; phone: string; website: string; message: string
}
function record(value: unknown): Record<string, unknown> {
  if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('Please check your application details.')
  return value as Record<string, unknown>
}
function text(body: Record<string, unknown>, key: string, label: string, max: number, required = true) {
  const value = body[key]
  if (!required && value === undefined) return ''
  if (typeof value !== 'string' || value.length > max || (required && !value.trim()) || /[\u0000-\u0008\u000b-\u001f\u007f]/.test(value)) throw new Error(`Please enter a valid ${label}.`)
  return value.trim()
}
export function parsePartnerBusiness(value: unknown) {
  const body = record(value)
  const company = text(body, 'company', 'agency or business name', 160)
  const website = text(body, 'website', 'website URL', 300, false)
  if (website) {
    let url: URL
    try { url = new URL(website) } catch { throw new Error('Enter a full website URL, such as https://youragency.com.') }
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password || !url.hostname.includes('.')) throw new Error('Please enter a valid public website URL.')
  }
  return { company, website, message: text(body, 'message', 'client details (up to 1,000 characters)', 1000, false) }
}
export function parsePartnerContact(value: unknown) {
  const body = record(value)
  const name = text(body, 'name', 'contact name', 120)
  const email = text(body, 'email', 'email address', 254).toLowerCase()
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) throw new Error('Please enter a valid email address.')
  const phone = text(body, 'phone', 'phone number with country code', 30)
  if (!isValidE164(phone)) throw new Error('Enter a valid phone number with country code, such as +91 98765 43210.')
  return { name, email, phone: phone.replace(/[^\d+]/g, '') }
}
/** Shared signup field validation; account creation requires a separate verified OTP. */
export function parsePartnerApplication(value: unknown): PartnerApplication {
  return { ...parsePartnerBusiness(value), ...parsePartnerContact(value) }
}
